import { useState } from "react";

// Components
import MailboxesDataGrid from "./MailboxesDataGrid";
import MailboxDeleteDialog from "./MailboxDeleteDialog";
import MailboxDrawer from "./MailboxDrawer";

import { SelectedMailboxesContext } from "../context/SelectedMailboxContext";
import MailboxesToolbar from "./MailboxesToolbar";

function Mailboxes() {
  const [isCreatorOpen, setIsCreatorOpen] = useState(false);
  const [isEditorOpen, setIsEditorOpen] = useState(false);
  const [isRemoverOpen, setIsRemoverOpen] = useState(false);

  return (
    <SelectedMailboxesContext>
      <MailboxesToolbar
        setIsAddOpen={setIsCreatorOpen}
        setIsEditOpen={setIsEditorOpen}
        setIsRemoverOpen={setIsRemoverOpen}
      />
      <div style={{ flex: 1, overflowY: "auto" }}>
        <MailboxesDataGrid data-testid="mailboxes-toolbar" />
      </div>
      <MailboxDrawer isOpen={isCreatorOpen} setIsOpen={setIsCreatorOpen} newMailbox={true} />
      <MailboxDrawer isOpen={isEditorOpen} setIsOpen={setIsEditorOpen} />
      {isRemoverOpen && <MailboxDeleteDialog isOpen={isRemoverOpen} setIsOpen={setIsRemoverOpen} />}
    </SelectedMailboxesContext>
  );
}

export default Mailboxes;
